import { render, staticRenderFns } from "./addFlightPriceModal.vue?vue&type=template&id=e362041e&scoped=true&"
import script from "./addFlightPriceModal.vue?vue&type=script&lang=ts&"
export * from "./addFlightPriceModal.vue?vue&type=script&lang=ts&"
import style0 from "./addFlightPriceModal.vue?vue&type=style&index=0&id=e362041e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e362041e",
  null
  
)

export default component.exports